import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SERVICE_LABELS } from "@/serviceTypes";

export default function ProfessionalServiceNav() {
  useUiLanguage();
  const {workspace}=useAuth(),location=useLocation(),navigate=useNavigate();
  if(workspace?.role!=="artist")return null;
  const types=workspace.service_types||["tattoo"],primary=workspace.primary_service_type||types[0];
  if(types.length<2)return null;
  const requested=new URLSearchParams(location.search).get("service_type");
  const active=types.includes(requested)?requested:primary;
  const choose=(value)=>{const query=new URLSearchParams(location.search);query.set("service_type",value);const modePage=["/app/artist", "/app/artist/services"].includes(location.pathname);navigate({pathname:modePage?(location.pathname==="/app/artist/services"||value!=="tattoo"?"/app/artist/services":"/app/artist"):location.pathname,search:query.toString()});};
  return <nav aria-label={tr("Attività professionali")} className="my-3 flex flex-wrap gap-2">{[primary,...types.filter(t=>t!==primary)].map(type=><button type="button" key={type} aria-pressed={type===active} onClick={()=>choose(type)} className={`rounded-full border px-3 py-2 text-sm ${active===type?"bg-primary text-primary-foreground":"bg-card"}`}>{SERVICE_LABELS[type]}{type===primary?tr(" · principale"):""}</button>)}</nav>;
}

